import React, { useState, useEffect } from "react";

import {
  generateSourceDashboardJsonPrompt,
  transformDataForMultibarChart,
} from "../../../utils/helpers";
import ReVerticalMultibarChart from "../common/ReVerticalMultibarChart";
import { getDashboardSummary } from "../../../services/apiService";
import AiIcon from "../../../assets/svgs/AIIcon";
import { Spinner } from "react-bootstrap";
import Markdown from "markdown-to-jsx";
import MUIButton from "./../../../Component/UI/MUIButton/MUIButton";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import classes from "./DashboardComponent.module.css";
import FilterSelection from "../common/FilterSelection";
import ReTableView from "../common/ReTableView";
import CustomDateFilter from "../common/CustomDateFilter";

const SourceComponent = ({
  positiveAttSource,
  negativeAttSource,
  categoryDimensionSource,
  categoryDimensionRatingSource,
  coreAttSourceData,
  reachSourceData,
  sentimentSourceData,
  brandProduct,
  isProductDashboard,
  sourceFilter,
  handleFilterChange,
  sourceAlias,
  activeTarget,
  updateCustomFilterState,
  frequency,
  customDatesToDisplay
}) => {
  const [summary, setSummary] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const reporting = typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("reporting") === "true" : false;

  // useEffect(() => {
  //   fetchSummary();
  // }, []);

  const positiveAttSourceBarChartData = transformDataForMultibarChart(
    positiveAttSource,
    true
  );
  const negativeAttSourceBarChartData = transformDataForMultibarChart(
    negativeAttSource,
    true
  );

  const categoryDimSourceBarChartData = transformDataForMultibarChart(
    categoryDimensionSource,
    true
  );
  const categoryDimRatingSourceBarChartData = transformDataForMultibarChart(
    categoryDimensionRatingSource,
    true
  );

  const coreAttSourceBarChartData = transformDataForMultibarChart(
    coreAttSourceData,
    true
  );
  const reachSourceBarChartData = transformDataForMultibarChart(
    reachSourceData,
    true
  );
  const sentimentSourceBarChartData = transformDataForMultibarChart(
    sentimentSourceData,
    true
  );

  const aggregatedBrandSources = mergeMultipleArrays(
    sentimentSourceBarChartData,
    positiveAttSourceBarChartData,
    negativeAttSourceBarChartData
  );

  const aggregatedCategorySources = mergeMultipleArrays(
    reachSourceBarChartData,
    categoryDimSourceBarChartData,
    categoryDimRatingSourceBarChartData,
    coreAttSourceBarChartData
  );

  const brandSourcesChartDataArray = sortArraysByLLMFrequency([
    aggregatedBrandSources,
    // sentimentSourceBarChartData,
    // positiveAttSourceBarChartData,
    // negativeAttSourceBarChartData,
  ]);

  const categorySourcesChartDataArray = sortArraysByLLMFrequency([
    aggregatedCategorySources,
    // reachSourceBarChartData,
    // categoryDimSourceBarChartData,
    // categoryDimRatingSourceBarChartData,
    // coreAttSourceBarChartData,
  ]);

  const getTruncatedText = () => {
    const words = summary?.split(" ");
    return words.slice(0, 30).join(" ") + (words.length > 50 ? "...." : "");
  };

  const fetchSummary = async () => {
    setIsLoading(true);
    try {
      const data = [brandSourcesChartDataArray, categorySourcesChartDataArray];
      const jsonData = generateSourceDashboardJsonPrompt(JSON.stringify(data));
      const payload = {
        entity: brandProduct,
        dashboardType: "sourceDashboard",
        jsonData,
      };
      const response = await getDashboardSummary(payload);
      setSummary(response);
    } catch (error) {
      console.error("Error fetching summary:", error);
    } finally {
      setIsLoading(false);
    }
  };

  function sortArraysByLLMFrequency(arrays) {
    return arrays?.map((array) => {
      // Dynamically determine the list of unique LLM keys in the current array
      const llmKeys = Array.from(new Set(array?.flatMap(Object.keys))).filter(
        (key) => key !== "name"
      ); // Exclude 'name' or any non-LLM key if necessary

      // Sort the array based on the count of LLM keys present in each object
      return array?.sort((a, b) => {
        const countLLMKeys = (obj) =>
          llmKeys.filter((key) => key in obj).length;
        return countLLMKeys(b) - countLLMKeys(a); // Sort in descending order
      });
    });
  }

  function mergeMultipleArrays(...arrays) {
    const merged = {};

    arrays.flat().forEach((item) => {
      if (item && typeof item.name === "string") {
        const { name, ...llms } = item;

        if (!merged[name]) {
          merged[name] = { ...llms };
        } else {
          // Merge LLM counts
          Object.entries(llms).forEach(([llm, count]) => {
            if (merged[name][llm]) {
              merged[name][llm] = String(
                Number(merged[name][llm]) + Number(count)
              );
            } else {
              merged[name][llm] = count;
            }
          });
        }
      }
    });

    const finalResult = Object.entries(merged).map(([name, llms]) => ({
      name,
      ...llms,
    }));

    return finalResult;
  }

  return (
    <>
      {/* <div className="col-md-12">
        <div className="graphGreyBg">
          <p style={{ display: "flex", justifyContent: "center" }}>
            <h4>Headlines</h4>
            &nbsp; &nbsp;
            <MUIButton
              onClick={fetchSummary}
              variant="outlined"
              className={classes.regenerate}
              startIcon={<AutoAwesomeOutlinedIcon />}
            >
              Generate
            </MUIButton>
          </p>
          <div className="graphsummary font-11">
            {isLoading ? (
              <div
                style={{
                  fontSize: "19px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                  // color: "green",
                }}
              >
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                &nbsp; Loading...
              </div>
            ) : summary && typeof summary === "string" ? (
              <>
                <Markdown className="markTable">
                  {isExpanded ? summary : getTruncatedText()}
                </Markdown>
                <span
                  style={{ cursor: "pointer", color: "blue" }}
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? "Show Less" : "Show More"}
                </span>
              </>
            ) : (
              // news
              ""
            )}
          </div>
        </div>
      </div> */}

      {frequency === 'Custom' && <CustomDateFilter
        activeTarget={activeTarget}
        handleChange={updateCustomFilterState}
        customDatesToDisplay={customDatesToDisplay}
      />}

      {!reporting && <div className=" customTabContent  col-md-3 mt-2 ">
        <div
          style={{ position: "relative" }}
          className="input-group input-group-lg mb-2"
        >
          <span className="input-group-text" id="basic-addon1">
            <i className="feather icon-target"></i>
          </span>
          <FilterSelection
            options={[
              { value: "LLM", label: "Compare by LLM" },
              { value: "PERSONA", label: "Compare by Persona" },
              { value: "CATEGORY", label: "Compare by Category" },
            ]}
            selectedOptions={sourceFilter}
            handleChange={(selectedOptions) =>
              handleFilterChange(selectedOptions)
            }
          />
        </div>
      </div>}

      {brandSourcesChartDataArray?.map((data, index) => {
        return (
          <div>
            <ReTableView
              type={isProductDashboard ? "Product" : "Brand"}
              data={data}
              sourceAlias={sourceAlias}
            />
          </div>
        );
      })}
      <hr />

      {categorySourcesChartDataArray?.map((data, index) => {
        return (
          <div>
            <ReTableView
              type="Category"
              data={data}
              sourceAlias={sourceAlias}
            />
          </div>
        );
      })}
    </>
  );
};

export default SourceComponent;
